import { observable, action, runInAction } from 'mobx';

export class IndicatorStore {
    constructor(botStore) {
        this.botStore = botStore;
    }

    @observable indicators = {};
    @observable cooldown = {};

    @action setIndicators(indicators) {
        this.indicators = indicators;
    }

    @action setCooldown(indicator, date) {
        if (date) {
            this.cooldown[indicator] = date;
            return;
        }
        this.cooldown[indicator] = false;
    }

    @action listen() {
        this.botStore.socket.on('indicators:update', ({ data }) => {
            runInAction(() => {
                this.indicators = data;
            });
        });

        const currentUser = this.botStore.rootStore.fbAuth.currentUser;

        if (!currentUser) return Promise.reject();

        if (!this.cdWatcher) {
            this.cdWatcher = this.botStore.rootStore.db
                .collection(
                    `/users/${currentUser.uid}/botConfigs/${this.botStore.currentBot}/symbols`
                )
                .onSnapshot(snapshot => {
                    snapshot.forEach(snap => {
                        if (snap.data().cooldown) {
                            const expiry = new Date(snap.data().cooldown.toDate());

                            this.setCooldown(
                                snap.id,
                                expiry.getTime() > Date.now() ? expiry.getTime() : false
                            );
                            return;
                        }
                        this.setCooldown(snap.id, false);
                    });
                });
        }
    }

    @action close() {
        this.indicators = {};
        this.cdWatcher && this.cdWatcher();
    }
}



// WEBPACK FOOTER //
// ./src/stores/IndicatorStore.js